import fetchTBTSignings from '../Services/fetchTBTSignings'

export default () => async (dispatch) => {
  // Fetch TBT signings with explicit sorting by created_at descending (latest first)
  dispatch(fetchTBTSignings({
    sort_field: 'created_at',
    sort_order: 'desc'
  }))
}
